import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { updatePhraseBidRemote } from '../../actions/phrases-grid';
import {
    EditableAutobudgetPriorityCell,
    EditableAutobudgetPriorityCellProps
} from '../../components/EditableAutobudgetPriorityCell/EditableAutobudgetPriorityCell';
import { PhraseBidChange } from '../../typings/domain';
import { GdShowConditionAutobudgetPriority } from '../../typings/graphql-grid';
import { TDispatchProps } from '../../typings/utils';

export interface OwnProps {
    id: string;
    groupId: string;
    autobudgetPriority?: GdShowConditionAutobudgetPriority;
    columnName: string;
    cls?: string;
}

export type DispatchProps = TDispatchProps<EditableAutobudgetPriorityCellProps>;

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    const { columnName } = ownProps;

    return {
        updatePhrase: (phrase: PhraseBidChange) => {
            dispatch(updatePhraseBidRemote(phrase, columnName));
        }
    };
};

export const EditableAutobudgetPriorityCellContainer = connect<{}, DispatchProps, OwnProps>(
    null,
    mapDispatchToProps
)(EditableAutobudgetPriorityCell);
